import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import { Button, unit } from '@acast/decibel';
import { PlaySolidGlyph, StopSolidGlyph } from '@acast/decibel-glyphs';

const Container = styled.div`
  display: flex;
  align-items: center;
  opacity: ${({ hasAudio }) => (hasAudio ? 1 : 0.5)};
`;

const Label = styled.div`
  margin-left: ${unit(4)};
`;

const createLabel = src => {
  if (!src) return 'No audio uploaded.';

  let fileName = src.substring(src.lastIndexOf('/') + 1);
  fileName = fileName.substring(fileName.indexOf('-') + 1);
  fileName = fileName.substring(fileName.indexOf('-') + 1);

  return fileName;
};

const AudioPreview = ({ src, onPlay, onStop, playing }) => {
  const handleAudioPlay = React.useCallback(() => {
    onPlay(src);
  }, [onPlay, src]);

  const handleAudioStop = React.useCallback(() => {
    onStop();
  }, [onStop]);

  return (
    <Container hasAudio={!!src}>
      <Button
        variant="tertiary"
        disabled={!src}
        glyph={playing ? StopSolidGlyph : PlaySolidGlyph}
        onClick={playing ? handleAudioStop : handleAudioPlay}
        aria-label="Play"
        aria-pressed={playing}
      />
      <Label data-test-id="AudioPreview__label">{createLabel(src)}</Label>
    </Container>
  );
};

AudioPreview.propTypes = {
  playing: T.bool,
  onPlay: T.func.isRequired,
  onStop: T.func.isRequired,
  src: T.string,
};

AudioPreview.defaultProps = {
  playing: false,
  src: undefined,
};

export default AudioPreview;
